import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../http-common";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isCompetitor, setIsCompetitor] = useState(false);
  const [isJury, setIsJury] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isInvestmentCommittee, setIsInvestmentCommittee] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const response = await http.post("/auth/login", {
        username,
        password,
      });
      const principal = {
        username: response.data.username,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        roleCode: response.data.roleCode,
        accessToken: response.data.accessToken,
      };
      setUser(principal);
      checkIsCompetitor(response.data.roleCode);
      setIsJury(response.data.roleCode === 204);
      setIsAdmin(response.data.roleCode === 200);
      setIsInvestmentCommittee(response.data.roleCode === 205);
      localStorage.setItem("principal", JSON.stringify(principal));
      navigate(
        checkIsCompetitor(response.data.roleCode)
          ? "/admin/home"
          : "/admin/dashboard"
      );
    } catch (error) {
      toast.error("Número de telefone ou senha inválidos");
    }
  };

  const checkIsCompetitor = (roleCode) => {
    let result = roleCode === 201;
    setIsCompetitor(result);
    return result;
  };

  const logout = () => {
    setUser(null);
    setIsCompetitor(false);
    setIsAdmin(false);
    setIsJury(false);
    setIsInvestmentCommittee(false);
    localStorage.removeItem("principal");
    navigate("/adm");
  };

  useEffect(() => {
    const loggedUser = localStorage.getItem("principal");
    if (loggedUser) {
      const parsed = JSON.parse(loggedUser);
      setUser(parsed);
      checkIsCompetitor(parsed.roleCode);
      setIsJury(parsed.roleCode === 204);
      setIsAdmin(parsed.roleCode === 200);
      setIsInvestmentCommittee(parsed.roleCode === 205);
    }
    setLoading(false);
  }, []);
  return (
    <AuthContext.Provider
      value={{
        authenticated: !!user,
        user,
        isCompetitor,
        isJury,
        isAdmin,
        isInvestmentCommittee,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
